
import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

declare global {
  interface Window {
    stackdriverErrorReporter: any;
  }
}

declare const StackdriverErrorReporter: any;

window.stackdriverErrorReporter = new StackdriverErrorReporter();
window.stackdriverErrorReporter.start({
  key: environment.stackdriverErrorReportingApiKey,
  projectId: environment.firebase.projectId,
  service: "my-wanderoo",
  version: environment.appVersion,
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
